module.exports = __webpack_public_path__ + "img/list-active.59a6be2d.svg";